export const assistantPanel = {
  title: '¡Hola, agente!\n¿Cómo puedo ayudarte hoy?',
  direct: 'Solo directos',
  entire: 'Toda la estructura',
  descriptionTop: 'Has seleccionado la sección {{value}}. A continuación se presenta un resumen de la información.',
  descriptionBottom:
    'Esta es una breve información sobre tu solicitud, haz clic en el botón y ve a la sección para estudiar la información completa.',
  openInPanel: 'Abrir en panel ',

  fields: {
    deposits_count: 'Número de depósitos',
    deposits_amount: 'Importe de depósitos',
    withdrawals_count: 'Número de retiradas',
    withdrawals_amount: 'Importe de retiradas',
    bets_count: 'Número de apuestas',
    bets_amount: 'Importe de apuestas',
    wins_amount: 'Importe de ganancias',
    netwin: 'Ganancia neta',

    deposits_sum: 'Suma de depósitos',
    withdrawals_sum: 'Suma de retiradas',

    active_players: 'Jugadores activos',
    inactive_players: 'Jugadores inactivos',
    new_players: 'Jugadores nuevos',
    top_players: 'Mejores jugadores',

    user_id: 'Id de usuario',
    number: 'Número',
    username: 'Nombre de usuario',
    wins_count: 'Número de ganancias',
    wins_sum: 'Suma de ganancias',
    bets_sum: 'Suma de apuestas',
    profit: 'Beneficio',

    total_agents: 'Total de agentes',
    top_agents: 'Mejores agentes',
    agent_id: 'Id de agente',
    direct_netwin_sum: 'Suma de ganancia neta directa',
    inactive_agents: 'Agentes inactivos',

    deposits_average: 'Depósito promedio',
    top_depositors: 'Mayores depositantes',
    top_withdrawers: 'Jugadores con más retiradas',

    bets_total: 'Total de apuestas',
    wins_total: 'Total de ganancias',

    biggest_losers: 'Mayores perdedores',
    biggest_winners: 'Mayores ganadores',

    cashback_awarded: 'Cashback concedido',
    cashback_players_count: 'Número de jugadores con cashback',
    cashback_history: 'Historial de cashback',

    id: 'Id',
    player_id: 'Id de jugador',
    cashback_amount: 'Importe de cashback',
    status: 'Estado',
    completed_at: 'Completado el',
  },

  //periods
  today: 'Hoy',
  yesterday: 'Ayer',
  lastWeek: 'Últimos 7 días',
  lastMonth: 'Últimos 30 días',
  currentMonth: 'Mes actual',
  choosePeriod: 'Elegir período',

  //sections
  general: 'Resumen general',
  players: 'Jugadores',
  structure: 'Estructura',
  deposits: 'Depósitos',
  withdrawals: 'Retiros',
  bets: 'Apuestas / Resultados',
  bonus: 'Bonos / Cashback',
  balance: 'Balance',
  partnerBalance: 'Balance del socio',

  //subsections
  completeReport: 'Resumen completo',
  totalDeposits: 'Depósitos totales',
  totalWithdrawals: 'Retiros totales',
  netwin: 'Netwin',
  activePlayers: 'Jugadores activos',

  playersActive: 'Activos',
  playersInactive: 'Inactivos',
  playersNew: 'Nuevos',
  playersTop: 'Top jugadores',

  agentsTotal: 'Total agentes',
  agentsTop: 'Top agentes',
  agentsInactive: 'Agentes inactivos',

  depositsTotal: 'Total depositado',
  depositsCount: 'Cantidad de depósitos',
  depositsAverage: 'Promedio de depósito',
  depositsTopPlayers: 'Top jugadores por depósito',

  withdrawalsTotal: 'Total retirado',
  withdrawalsCount: 'Cantidad de retiros',
  withdrawalsTopPlayers: 'Top retiros',

  betsTotal: 'Total apostado',
  winsTotal: 'Total ganado',
  playersBiggestLosses: 'Jugadores con mayores pérdidas',
  playersBiggestWins: 'Jugadores con mayores ganancias',

  cashbackAwarded: 'Cashback otorgado',
  cashbackPlayersCount: 'Cantidad de jugadores con cashback',
  cashbackHistory: 'Historial de cashback',

  addClarification: 'Agregue una aclaración...',
};
